import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

export default function Login() {
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation() as any;
  const from = location.state?.from || "/admin";

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setErr(null);
    try {
      await login(password);
      navigate(from, { replace: true });
    } catch (e: any) {
      setErr("That password isn't right.");
    }
  }

  return (
    <div className="login">
      <form onSubmit={onSubmit} className="login-card">
        <h1>Sign in</h1>
        <p className="muted">This area is just for the two of us.</p>
        <label>
          Password
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoFocus
            required
          />
        </label>
        <button className="button" type="submit">
          Sign in
        </button>
        {err && <p className="error">{err}</p>}
      </form>
    </div>
  );
}
